module.exports = __webpack_public_path__ + "media/images/placeholder-completed-8cbe4b69.png";